import { FSA } from 'flux-standard-action';
import { 
  ConfigurationKeys, 
  ApronBackSplashKeys, 
  AssemblyAccessoriesKeys, 
  BuiltInPartsKeys, 
  DrainAccessoriesKeys, 
  SelectedTroughKeys, 
  WashBasinDimensionKeys,
  ConfigurationModel, 
  ConfigurationDefaultModel
} from 'franke-trough-dependencies';

export interface WarningsRequestApprovalPayload {
  key: string;
  type?: ConfigurationKeys;
  subType?: ApronBackSplashKeys | AssemblyAccessoriesKeys | BuiltInPartsKeys | DrainAccessoriesKeys | SelectedTroughKeys | WashBasinDimensionKeys;
}

export interface WarningChangedPayload {
  configuration: ConfigurationModel;
  defaults: ConfigurationDefaultModel;
  initialRequest: boolean;
}

export type WarningsFsaTypes = string | WarningChangedPayload | WarningsRequestApprovalPayload;

export enum WarningActionTypes {
  Approve = '@warnings/Approve',
  Changed = '@warnings/Changed',
  Clear = '@warnings/Clear',
  Decline = '@warnings/Decline',
  RequestApproval = '@warnings/RequestApproval',
} 

export const warnings = {
  approve: (payload: string): FSA<WarningActionTypes.Approve, string> => ({
    payload,
    type: WarningActionTypes.Approve,
  }),
  changed: (payload: WarningChangedPayload): FSA<WarningActionTypes.Changed, WarningChangedPayload> => ({
    payload,
    type: WarningActionTypes.Changed,
  }),
  clear: (): FSA<WarningActionTypes.Clear, undefined> => ({
    type: WarningActionTypes.Clear
  }),
  decline: (payload: string): FSA<WarningActionTypes.Decline, string> => ({
    payload,
    type: WarningActionTypes.Decline,
  }),
  requestApproval: (payload: WarningsRequestApprovalPayload): FSA<WarningActionTypes.RequestApproval, WarningsRequestApprovalPayload> => ({
    payload,
    type: WarningActionTypes.RequestApproval,
  }),
};